module.exports = __webpack_public_path__ + "static/Dashboard_highres-95bb8cb5989eecc720b076308bef25ba.jpg";